import ImageLoader from "./ImageLoader";

const ImagePopup = ({ imageLoading, setShowImagePopup, currentPopupImage }) => {
  return (
    <div
      className="fixed inset-0 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto z-[1000]"
      onClick={() => setShowImagePopup(false)}
    >
      {/* outer div */}
      <div className="relative bg-white rounded-2xl shadow-lg p-3 mt-10 animate-slide-down z-[1001] border-2 border-black">
        {/* inner div for two borders */}
        <div
          className="relative bg-white rounded-2xl shadow-lg px-4 py-6 animate-slide-down z-[1001] border-2 border-black"
          onClick={(e) => e.stopPropagation()}
        >
          {imageLoading ? (
            <div className="flex justify-center items-center w-[90vw] sm:w-[500px] h-[60vh] sm:h-[50vh]">
              <ImageLoader />
            </div>
          ) : (
            <div className="flex flex-col w-[90vw] sm:w-[500px] min-h-[70vh] sm:min-h-[70vh]">
              <img
                src="assets/images/isp_logo01.png"
                className="h-[40%] w-[40%] pl-2"
                alt=""
              />
              <img
                className="mt-4 max-w-full max-h-full"
                src={currentPopupImage}
                alt="pop up image"
              />
            </div>
          )}
          <div className="flex justify-end items-center mt-4">
            <button
              className="bg-[#002060] text-white px-2.5 py-1 rounded-xl mr-2"
              onClick={() => setShowImagePopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePopup;
